/**
 * Converts a number to the number + K or M
 * @param value The number to convert
 * @returns The formatted string with K or M suffix
 */
export const convertHighCount = (value: number): string => {
  const numbers: Record<string, number> = {
    K: 1000,
    M: 1_000_000,
  }

  let formatted = value
  let suffix = ''

  for (const [k, v] of Object.entries(numbers)) {
    if (value >= v) {
      suffix = k
      formatted =
        value % v <= 99 && value % v >= 0 ? Math.floor(value / v) : Number((value / v).toFixed(1))
    }
  }

  return `${formatted}${suffix}`
}
